import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'home',
		component: Home
	},
	{
		path: '/about',
		name: 'about',
		component: () => import( '../views/About.vue' )
	},
	{
		path: '/character',
		name: 'character',
		component: () => import( '../views/Character.vue' )
	},
	{
		path: '/weapons',
		name: 'weapons',
		component: () => import( '../views/Weapons.vue' )
	},
	// {
	// 	path: '/weather',
	// 	name: 'weather',
	// 	component: () => import( '../views/Weather.vue' )
	// },
	{
		path: '/output',
		name: 'output',
		component: () => import( '../views/Output.vue' )
	},
	{
		path: '/settings',
		name: 'settings',
		component: () => import( '../views/Settings.vue' )
	},

	// ported from the readme.md
	{
		path: '/guides',
		name: 'guides',
		component: () => import( '../views/Guides.vue' )
	},


	//@TODO
	{
		path: '/levelconfig',
		name: 'levelconfig',
		component: () => import( '../views/LevelConfig.vue' )
	},
]

export default new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior ( to, from, savedPosition ) {
		if ( savedPosition ) {
			return savedPosition;
		} else {
			return { x: 0, y: 0 }
		}
	}
})

// export default router
